import { render, staticRenderFns } from "./OrderSelectCurrency.vue?vue&type=template&id=5cc31fe2&"
import script from "./OrderSelectCurrency.vue?vue&type=script&lang=js&"
export * from "./OrderSelectCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports